import React from 'react';
import { Field } from 'formik';
import TextFieldMain from '../../Shared/TextFieldMain';

const InputToken = ({
  idx,
  values,
  isPending,
  isSubmitting,
  setFieldValue,
  setFieldTouched,
  inputRefs,
  limpaMsgErro
}) => {
  const chars = (values.TOKENVALIDACAO || '').toUpperCase().padEnd(6, ' ').split('').slice(0, 6);
  const char = chars[idx].trim();

  const handleInputChange = e => {
    const entered = (e.target.value.toUpperCase().match(/[A-Z0-9]/) || [''])[0];
    const arr = [...chars];
    arr[idx] = entered;
    const newValue = arr.join('').trimEnd().toUpperCase();
    setFieldValue('TOKENVALIDACAO', newValue, true);
    limpaMsgErro(e);

    if (entered && idx < 5) {
      setTimeout(() => {
        inputRefs.current[idx + 1]?.focus();
      }, 10);
    }
  };

  const handleKeyDown = e => {
    if (e.key === 'Backspace') {
      e.preventDefault();
      const arr = [...chars];
      if (arr[idx].trim()) {
        // apaga o caractere deste índice
        arr[idx] = ' ';
        setFieldValue('TOKENVALIDACAO', arr.join('').trimEnd(), true);
      } else if (idx > 0) {
        // volta para o anterior
        arr[idx - 1] = ' ';
        setFieldValue('TOKENVALIDACAO', arr.join('').trimEnd(), true);
        setTimeout(() => {
          inputRefs.current[idx - 1]?.focus();
        }, 0);
      }
    }
  };

  const handlePaste = e => {
    e.preventDefault();
    const pasted = e.clipboardData
      .getData('Text')
      .toUpperCase()
      .replace(/[^A-Z0-9]/g, '')
      .slice(0, 6);

    setFieldValue('TOKENVALIDACAO', pasted, true);
    setFieldTouched('TOKENVALIDACAO', true, false);
    limpaMsgErro(e);

    const nextIdx = pasted.length < 6 ? pasted.length : 5;
    setTimeout(() => {
      inputRefs.current[nextIdx]?.focus();
    }, 0);
  };

  return (
    <Field name="TOKENVALIDACAO">
      {({ field, form }) => (
        <TextFieldMain
          field={{ ...field, value: char }}
          form={{ ...form, errors: {}, touched: {} }}
          variant="standard"
          label=""
          helperText=""
          placeholder=" "
          autoComplete="off"
          inputProps={{
            maxLength: 1,
            style: { textTransform: 'uppercase' },
            onKeyDown: handleKeyDown,
            onPaste: handlePaste
          }}
          inputRef={el => {
            if (el) inputRefs.current[idx] = el;
          }}
          inputClassName="input-confirmacao-digit is-filled-pin"
          onChangeInput={handleInputChange}
          onBlur={() => setFieldTouched('TOKENVALIDACAO', true)}
          disabled={isPending || isSubmitting}
        />
      )}
    </Field>
  );
};

export default InputToken;
